<!-- eslint-disable max-len -->
<template>
  <svg fill="none" height="16" viewBox="0 0 21 21" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.0009918,10.5 C17.0003887,13.7341181 14.6222051,16.4758376 11.4206191,16.9334042 C8.21903303,17.3909708 5.16805801,15.4251798 4.26155127,12.3207046 C3.35504452,9.21622948 4.86879117,5.91753976 7.81353541,4.58037792 C10.7582797,3.24321608 14.2381466,4.27438476 15.9789918,7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <polyline points="16.0009918 3 16.0009918 7 12.0009918 7" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
